<template>
    <base-button
        type="button"
        class="background--transparent accessibility--button"
        :hasHover="hasHover"
        :customClass="true"
        v-on="{
            ...( action.execute && {
                click: click
            })
        }"
    >
        <template #button__icon>
            <component
                v-if="icon"
                :is="icon.component"
                :class="icon.class"
                v-bind="{ ...icon.props }"
                tabindex="-1"
            />
            <slot name="icon-with-animation" />
        </template>
        <template #button__text>
            <span v-if="text">
                {{ text }}
            </span>
        </template>

    </base-button>
</template>

<script>
// TODO: button outline only on tab
// TODO: ler isto https://stackoverflow.com/questions/31402576/enable-focus-only-on-keyboard-use-or-tab-press
// TODO: ler isto https://stackoverflow.com/questions/50465564/tabindex-outlines-only-with-tab-button
export default {
    components: {
        BaseButton: () => import( /* webpackChunkName: 'BaseButton' */ '@/components/bundles/buttons/BaseButton' )
    },
    props: {
        text: String,
        icon: Object,
        hasHover: {
            type: Boolean,
            default: false
        },
        action: {
            type: Object,
            default: () => ({ })
        }
    },
    setup ( props ) {
        /**
         * Click no botão.
         * De forma a conseguir passar parametros, foi necessário
         * criar uma função especifica apenas para o click.
         *
         * @since 1.0.0
         * @category Method
         * @autor Tiago Martinho
         *
        */
        const click = () => {
            props.action.function( props.action.param );
        };

        return { click };
    }
};
</script>